<template>
  <div id="app">
     <router-view class="app-inner"/>
  </div>
</template>

<script>

export default {
  name: 'app',
  components: {
  }
}
</script>

<style>
body{
  margin: 0;
  font-family: source-han-sans-simplified-c, sans-serif;
  font-feature-settings:"kern", "liga", "clig", "calt";
  font-kerning: normal;
  box-sizing: border-box;
  font-size: 16px;
}
#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  /* text-align: center; */
  color: #2c3e50;
  height: 100vh;
}
.btn-normal{
  box-shadow: 0 2px 3px 0 rgba(44,71,146,0.32);
  background: linear-gradient(180deg, #648CFF 0%, #3973FF 100%);
  border-radius: 3px;
  height: 40px;
  color: white;
  line-height: 40px;
  text-align: center;
  cursor: pointer;
}
a{
  text-decoration: none;

}
.app-inner{
  display: inline-flex;
  width: 100%;
  flex-direction: column;
  align-items: center;
}
canvas{
    position: absolute;
    top: 0px;
    left: 0px;
    opacity: 1;
    transform: scale(0.8);
    z-index: 99999999;
    transition: transform 0.3s cubic-bezier(0.42, 0, 0.58, 1) 0s, opacity 0.3s cubic-bezier(0.42, 0, 0.58, 1) 0s, -webkit-transform 0.3s cubic-bezier(0.42, 0, 0.58, 1) 0s;
    
}
</style>
